import React from 'react'

import { Checkbox, FormControlLabel } from '@material-ui/core'
import { Col, Row } from 'react-bootstrap'

import { InputV2 } from '../../../../Components/Form/InputV2'
import { email } from '../../../../Utils/Validators/formValidation'
import SubmitButton from '../../../../Components/Form/Button'
import DeleteIcon from '@material-ui/icons/DeleteForever'

const UserRow = ({ classes, user, onDelete, onChange, isEditMode }) => {
  const onHandleChange = ({ key, value }) => {
    onChange({
      id: user.id,
      key,
      values: {
        ...user[key],
        value,
        error:
          key === 'email'
            ? email(value) || !value.length
            : user[key].required && !value.length,
      },
    })
  }
  return (
    <Row xs={12} className={classes.userRow}>
      <Col xs={3}>
        <InputV2
          disabled={!isEditMode}
          label={`First Name`}
          value={user.firstName.value}
          onChange={e =>
            onHandleChange({ key: 'firstName', value: e.target.value })
          }
        />
        {user.firstName.error ? (
          <div className={classes.error}>Required</div>
        ) : (
          <div />
        )}
      </Col>
      <Col xs={3}>
        <InputV2
          disabled={!isEditMode}
          label={`Last Name`}
          value={user.lastName.value}
          onChange={e =>
            onHandleChange({ key: 'lastName', value: e.target.value })
          }
        />
        {user.lastName.error ? (
          <div className={classes.error}>Required</div>
        ) : (
          <div />
        )}
      </Col>
      <Col xs={3}>
        <InputV2
          disabled={!isEditMode}
          label={`Email`}
          value={user.email.value}
          onChange={e =>
            onHandleChange({ key: 'email', value: e.target.value })
          }
        />
        {user.email.error ? (
          <div className={classes.error}>Invalid email address</div>
        ) : (
          <div />
        )}
      </Col>
      <Col xs={2}>
        <FormControlLabel
          control={
            <Checkbox
              disabled={!isEditMode}
              checked={user.includeInEmails.value}
              onClick={e =>
                onHandleChange({
                  key: 'includeInEmails',
                  value: e.target.checked,
                })
              }
              color="primary"
            />
          }
          label={`Include In Emails`}
        />
      </Col>
      <Col xs={1}>
        {isEditMode ? (
          <SubmitButton
            style={{
              height: '44px',
              width: '32px',
              padding: '22px',
              minWidth: '34px',
            }}
            onClick={() => onDelete(user.id)}
          >
            <DeleteIcon
              color="#FFFFFF"
              fill="#FFFFFF"
              width="14px"
              height="100%"
            />
          </SubmitButton>
        ) : null}
      </Col>
    </Row>
  )
}

export default UserRow
